import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { getCookie, useViewport } from '@chilecompra/react-kit'
import { Button } from '@chilecompra/react-kit/components'

import { useAuthorization } from '../AuthorizationProvider/AuthorizationProvider.hooks'
import { onOpenSelectOfferDialog } from '../SelectOfferDialog/SelectOfferDialog.actions'

import routes from '../../config/settings/routes'
import { QUOTE_STATUSES_DICTIONARY } from '../../config/settings/constants'

import { Divider, GridContainer, GridItem, Root } from './QuoteBid.styles'

/**
 * The Quote Bid Footer's container.
 */
const QuoteBidFooter = props => {
  const {
    bidding,
    disabledSubmit,
    inFirstCall,
    loadingSelected,
    noBidsLeft,
    onCancel,
    onOpenModalDeserted,
    onSecondCall,
    statusId
  } = props

  const { authInfo } = useSelector(state => state.authorizationProvider)
  const dispatch = useDispatch()
  const { isBuyer } = useAuthorization()
  const navigate = useNavigate()
  const {
    size: { isDownToTiny, isDownToSmall }
  } = useViewport()

  const handleSubmit = () => dispatch(onOpenSelectOfferDialog())
  const handleBack = () => {
    const query = getCookie('search')
    navigate({ pathname: routes.search, search: query.toString() }, { replace: true })
  }

  return (
    <Root>
      <Divider />
      <GridContainer padding="21px 0">
        <GridItem md={6} xs={12}>
          <Button
            type="button"
            variant="outlined"
            width={isDownToTiny || isDownToSmall ? '100%' : undefined}
            onClick={handleBack}
          >
            Volver
          </Button>
          {isBuyer && statusId === QUOTE_STATUSES_DICTIONARY.PUBLISHED && !authInfo.hasObserverRole && (
            <Button
              color="error"
              margin={!isDownToTiny && !isDownToSmall && '0 0 0 32px'}
              onClick={onCancel}
              type="button"
              variant="outlined"
              width={isDownToTiny || isDownToSmall ? '100%' : undefined}
            >
              Cancelar Compra Ágil
            </Button>
          )}
        </GridItem>
        <GridItem style={{ display: 'flex' }} md={6} xs={12} display="flex" justifyContent="flex-end">
          {!noBidsLeft && isBuyer && statusId === QUOTE_STATUSES_DICTIONARY.CLOSED && bidding && (
            <Button
              color="success"
              disabled={!disabledSubmit || authInfo.hasObserverRole || loadingSelected}
              loading={loadingSelected}
              onClick={handleSubmit}
              type="button"
              width={isDownToTiny || isDownToSmall ? '100%' : undefined}
            >
              Ir a emitir orden de compra
            </Button>
          )}
          {noBidsLeft && isBuyer && statusId === QUOTE_STATUSES_DICTIONARY.CLOSED && (
            <Button
              color="error"
              margin={!isDownToTiny && !isDownToSmall && '0 0 0 32px'}
              onClick={onOpenModalDeserted}
              type="button"
              variant="outlined"
              width={isDownToTiny || isDownToSmall ? '100%' : undefined}
            >
              Declarar desierta
            </Button>
          )}
          {inFirstCall && noBidsLeft && isBuyer && statusId === QUOTE_STATUSES_DICTIONARY.CLOSED && bidding && (
            <Button
              width={isDownToTiny || isDownToSmall ? '100%' : undefined}
              color="primary"
              onClick={onSecondCall}
              type="button"
              style={{
                marginLeft: '15px'
              }}
            >
              Realizar segundo llamado
            </Button>
          )}
        </GridItem>
      </GridContainer>
    </Root>
  )
}

QuoteBidFooter.defaultProps = {
  statusId: undefined
}

QuoteBidFooter.propTypes = {
  bidding: PropTypes.bool,
  disabledSubmit: PropTypes.bool.isRequired,
  inFirstCall: PropTypes.bool,
  loadingSelected: PropTypes.bool,
  noBidsLeft: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onOpenModalDeserted: PropTypes.func.isRequired,
  onSecondCall: PropTypes.func.isRequired,
  statusId: PropTypes.number
}

export default QuoteBidFooter
